export class BillsPaymentDetail {
  barCode = '';
  recipientDocument = '';
  description = '';
  protocolId = '';
  value = 0.0;
  valuePaid = 0.0;
  penalty = 0.0;
  discount = 0.0;
  createdAt = '';
  status = '';
  paymentDate = '';
  canceledDate = '';
  rejectedDate = '';
  chargebackAt = '';
  details = [];

  preset = {
    holder: {
      fullName: '',
    },
  };

  constructor(initData = {}) {
    Object.assign(this, initData);
  }
}
